/* Gift box add-on under each bottle (snippets/gift-box-addon.liquid): sets how many boxes a bottle has.
   After the change the drawer is re-rendered and "cart:updated" is fired without the sg flag, so
   gift-upsell.js runs sgSync() and brings the order note (picking docket) in step with the boxes.

   Checkout check: if the basket has gift boxes but some boxable bottles aren't boxed (e.g. 1 box, 4 bottles),
   pressing Checkout asks once: "Box all" or "That's right, continue". "Continue" stores the basket's box
   layout in the cart attribute _box_ok; gift-upsell.js then writes "customer confirmed" on the docket.
   If the basket changes afterwards, the layout no longer matches and the question is asked again. */
(() => {
  if (window.__sgAddon) return;
  window.__sgAddon = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const api = (path, body) => fetch(root + path, body ? {
    method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
  } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(r => {
    // The cookie-banner script can hold cart updates back and return a bare { ok: false } stand-in.
    if (typeof r.json !== 'function') throw { description: 'Please respond to the cookie banner first, then try again.' };
    return r.json().then(d => { if (!r.ok) throw d; return d; });
  });
  const onCartPage = /\/cart\/?$/.test(location.pathname);
  const money = c => {
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) {}
    return '£' + (c / 100).toFixed(2);
  };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // Same rules as gift-upsell.js, so both files build the same box layout string.
  const ov = document.getElementById('sg-overlay');
  const BOX = (ov && ov.dataset.boxHandle) || 'spiritly-luxury-gift-box';
  const isCard = i => !!i.handle && i.handle.indexOf('spiritly-greeting-card-') === 0;
  const isBox = i => i.handle === BOX && i.properties && i.properties._for;
  const isBottle = i => !isCard(i) && i.handle !== BOX && !i.gift_card && i.product_type !== 'Spiritly Gifting';
  window.sgBoxSig = cart => {
    const bq = {}, bx = {};
    cart.items.forEach(i => {
      if (isBox(i)) bx[i.properties._for] = (bx[i.properties._for] || 0) + i.quantity;
      else if (isBottle(i)) bq[i.variant_id] = (bq[i.variant_id] || 0) + i.quantity;
    });
    return Object.keys(bq).sort().map(k => `${k}:${bx[k] || 0}/${bq[k]}`).join(',');
  };

  function refresh(fire = true) {
    if (onCartPage) { location.reload(); return new Promise(() => {}); }
    const recs = document.getElementById('cart-recommendations');
    const recHTML = recs ? recs.innerHTML : '';
    return fetch(root + 'cart?view=drawer&t=' + Date.now(), { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cur = document.getElementById('CartDrawer'), nxt = doc.getElementById('CartDrawer');
        if (cur && nxt) {
          cur.innerHTML = nxt.innerHTML;
          const r = document.getElementById('cart-recommendations');
          if (r && recHTML) r.innerHTML = recHTML;
        }
        return api('cart.js');
      })
      .then(cart => {
        const cur = document.getElementById('CartDrawer');
        if (cur) cur.classList.toggle('is-empty', !cart.item_count);
        document.querySelectorAll('.cart-link__bubble').forEach(b => b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0));
        if (fire) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      });
  }

  // Set one bottle's box count. keys = its existing box lines (the first takes the count, others are merged in).
  function setBoxes(row, want) {
    const keys = row.dataset.keys.split(',').filter(Boolean);
    if (keys.length) return api('cart/update.js', { updates: Object.fromEntries(keys.map((k, i) => [k, i === 0 ? want : 0])) });
    if (want > 0) return api('cart/add.js', { items: [{ id: +row.dataset.box, quantity: want, properties: { 'Gift box for': row.dataset.title, _for: row.dataset.vid } }] });
    return Promise.resolve();
  }

  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-sg-box]');
    if (!b) return;
    const row = b.closest('[data-sg-addon]');
    if (!row || row.classList.contains('is-busy')) return;
    e.preventDefault();
    const max = +row.dataset.max;
    const want = b.dataset.sgBox === 'all' ? max : Math.max(0, Math.min(max, +row.dataset.n + +b.dataset.sgBox));
    row.classList.add('is-busy');
    row.querySelectorAll('button').forEach(x => (x.disabled = true));
    if (row.matches('button')) row.disabled = true;
    setBoxes(row, want).then(() => refresh()).catch(x => {
      row.classList.remove('is-busy');
      row.querySelectorAll('button').forEach(x => (x.disabled = false));
      if (row.matches('button')) row.disabled = false;
      alert((x && x.description) || 'Sorry, something went wrong. Please try again.');
    });
  });

  // ---- Checkout check for part-boxed baskets
  let dlg = null, pending = null;
  function build() {
    dlg = document.createElement('div');
    dlg.className = 'sg-confirm';
    dlg.hidden = true;
    dlg.innerHTML = `<div class="sg-confirm__bg" data-sgc-close></div>
      <div class="sg-confirm__box" role="dialog" aria-modal="true" aria-labelledby="sgc-h">
        <button type="button" class="sg-confirm__x" data-sgc-close aria-label="Close">×</button>
        <h2 class="sg-confirm__h" id="sgc-h">Check your gift boxes</h2>
        <p class="sg-confirm__p">Each gift box holds one bottle. These bottles won’t be boxed:</p>
        <ul class="sg-confirm__list" data-sgc-list></ul>
        <p class="sg-confirm__err" data-sgc-err hidden></p>
        <button type="button" class="sg-confirm__all" data-sgc-all></button>
        <button type="button" class="sg-confirm__ok" data-sgc-ok>That’s right, continue to checkout</button>
      </div>`;
    document.body.appendChild(dlg);
    // Keep clicks and keys inside the dialog away from the theme's drawer handlers (outside-click close etc.).
    dlg.addEventListener('click', e => {
      e.stopPropagation();
      if (e.target.closest('[data-sgc-close]')) close();
      else if (e.target.closest('[data-sgc-all]')) boxAll();
      else if (e.target.closest('[data-sgc-ok]')) confirmAsIs();
    });
    dlg.addEventListener('keydown', e => {
      e.stopPropagation();
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') {
        const f = [...dlg.querySelectorAll('button:not([disabled])')], a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    window.addEventListener('keyup', e => { if (!dlg.hidden) e.stopImmediatePropagation(); }, true);
  }
  function open(short, btn) {
    if (!dlg) build();
    const extra = short.reduce((a, r) => a + (+r.dataset.max - +r.dataset.n) * +r.dataset.price, 0);
    dlg.querySelector('[data-sgc-list]').innerHTML = short.map(r => {
      const n = +r.dataset.n, max = +r.dataset.max, left = max - n;
      return `<li><b>${esc(r.dataset.title)}</b> × ${max}<span>${n ? `${n} boxed · ` : ''}${left} not boxed</span></li>`;
    }).join('');
    dlg.querySelector('[data-sgc-all]').textContent = `Box them all and check out · +${money(extra)}`;
    err('');
    pending = { short, btn };
    dlg.hidden = false;
    document.documentElement.classList.add('sg-lock');
    setTimeout(() => dlg.querySelector('[data-sgc-all]').focus(), 30);
  }
  function close() {
    if (!dlg || dlg.hidden) return;
    dlg.hidden = true;
    document.documentElement.classList.remove('sg-lock');
    const b = pending && pending.btn; pending = null;
    if (b && document.contains(b)) b.focus();
  }
  function err(m) { const el = dlg.querySelector('[data-sgc-err]'); el.textContent = m; el.hidden = !m; }
  function busy(on) { dlg.querySelectorAll('button').forEach(b => (b.disabled = on)); dlg.classList.toggle('is-busy', on); }
  // Write the docket note (gift-upsell.js), then go to checkout.
  const toCheckout = () => (window.sgNote ? window.sgNote() : Promise.resolve()).catch(() => {}).then(() => { location.href = root + 'checkout'; });
  function confirmAsIs() {
    busy(true);
    api('cart.js')
      .then(cart => api('cart/update.js', { attributes: { _box_ok: window.sgBoxSig(cart) } }))
      .then(toCheckout)
      .catch(x => { busy(false); err((x && x.description) || 'Sorry, something went wrong. Please try again.'); });
  }
  function boxAll() {
    const short = pending ? pending.short : [];
    busy(true);
    short.reduce((p, r) => p.then(() => setBoxes(r, +r.dataset.max)), Promise.resolve())
      .then(() => (onCartPage ? null : refresh(false)))
      .then(toCheckout)
      .catch(x => { busy(false); err((x && x.description) || 'Sorry, something went wrong. Please try again.'); });
  }

  window.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || btn.dataset.sgPass) return;
    const form = btn.form || btn.closest('form');
    if (!form) return;
    // Leave the theme's own terms-and-conditions check alone.
    const terms = form.querySelector('.cart__terms-checkbox');
    if (btn.dataset.termsRequired === 'true' && terms && !terms.checked) return;
    const rows = [...form.querySelectorAll('[data-sg-addon]')];
    const anyBoxed = rows.some(r => +r.dataset.n > 0);
    const short = rows.filter(r => +r.dataset.n < +r.dataset.max);
    if (!anyBoxed || !short.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    api('cart.js').then(cart => {
      if (cart.attributes && cart.attributes._box_ok && cart.attributes._box_ok === window.sgBoxSig(cart)) return toCheckout();
      open(short, btn);
    }).catch(() => open(short, btn));
  }, true);
})();
